const locales = ["fr", "en"];

export default locales;
